import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation, IOperationListColumnResponse } from '../../airport-interfaces';
import { TabViewModule } from 'primeng/primeng';
import { TabView } from 'primeng/primeng';
import { TabPanel } from 'primeng/primeng';

import { AirportService } from '../../airport.service';
import { IScenario, ScenarioService } from '../../../scenario-activities/scenario.service';

import { UserSession } from '../../../shared/user-session';
import { UserInfoService } from '../../../shared/user-info.service';

import { UIChart} from 'primeng/primeng';
import * as _ from 'lodash';

@Component({
    template: require('./operations-graph-display.component.html'),
    styles: [require('../../../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, UIChart]
})

export class OperationsGraphDisplayComponent implements OnInit, OnDestroy{
    pageTitle: string;
    errorMessage: string;
    private sub: any;    

    currentScenario: IScenario;
    allScenarios: IScenario[];

    tableName: string;
    displayName: string;
    allOperations: IOperation[];
    locId: string;
    airportName: string;
    graphType: string = "bar";
    graphOptions:any;

    startYear: number;
    endYear: number;

    columns: IOperationListColumnResponse[];

    result: any;
    data: any;
    quickGraph: string;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService) {
    }

    ngOnInit(): void{
        this.sub = this.route.params.subscribe(
            params => {
                this.tableName = params['tableName'];
                this.displayName = params['displayName'];
                this.locId = params['locId'];
                this.airportName = params['airportName'];
                this.graphType = params['graphType'];
                this.startYear = params['startYear'];
                this.endYear = params['endYear'];
                this.quickGraph = params['quickGraph'];
                
                this.columns = JSON.parse(sessionStorage.getItem('operations-graph-columns'));

                this.getGraphData();
            }
        );

        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );
    }


    getGraphData(){

        let params = {
            tableName: this.tableName,
            locId: this.locId,
            scenarioId: this.User.getSession().scenarioId,
            startYear: this.startYear,
            endYear: this.endYear,
            columns: this.columns
        }

        this._airportService.getGraphData(params)
            .subscribe(
                result => {
                    this.result = result;

                    this.createGraphDataSet();
                }
            );
    }

    createGraphDataSet(){

        let labels = _.map(this.result,'AYEAR');
        let datasets: any[] = [];

        for(let index in this.columns)
        {
            let dataset = {
                    label: this.columns[index].graphName,
                    data: _.map(this.result, this.columns[index].graphName),
                    fill: false,
                    
                    backgroundColor: this.getRandomColor(),
                    borderColor: this.getRandomColor()
            }

            datasets[index] = dataset;
        }
        
        this.data = {
           labels: labels,
           datasets: datasets
        }
        this.graphOptions = {
                scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true
                            }
                        }]
                    }
        };
   }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
    }


    backFacilityView(){
        this.router.navigate([`/airports/${this.locId}`]);
    }

    backDataSheet(){

        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-list/${this.tableName}`, params]);
    }

    backSelections(){
        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-graph/${this.tableName}`, params]);
    }

    getRandomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        
        for (let i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * 16)];
        }

        return color;
    }

    backReforecast(){
        
        let params = {
            locId: this.locId,
            fieldName: this.columns[0].fieldName,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-reforcast/${this.tableName}`, params]);
    }
}



/** WEBPACK FOOTER **
 ** ./app/airports/Operations-lists/operations-graphs/operations-graph-display.component.ts
 **/